// @ts-nocheck
import {
    getGeneralDocumentationsList,
    GetProductCatalogsApiParameter,
} from "@store/Framework/Services/StoreAccountService";
import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetProductCatalogsApiParameter, string[]>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadGeneralDocuments: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/ProductCatalogs/BeginLoadGeneralDocuments",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getGeneralDocumentationsList();
    } catch (error) {
        return false;
    }
};

export const DispatchCompleteLoadGeneralDocuments: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/ProductCatalogs/CompleteLoadGeneralDocuments",
        result: props.apiResult,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadGeneralDocuments,
    RequestDataFromApi,
    DispatchCompleteLoadGeneralDocuments,
];

const loadGeneralDocuments = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadGeneralDocuments");
export default loadGeneralDocuments;
